import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  isBarAndBench,
  isCDR,
  isDigipub,
  isHotStar,
  isMuthoot,
  isNbf,
  isOrix,
  isStar,
  isViacom,
  isVikalp,
  isWebnyay,
} from "Routes/Routes";
import { getCompaniesByGroupAnonymous } from "slices/companySlice";
import Intro from "./introBeforeLogin";

export const introFormContext = React.createContext();

export default function IntroBeforeLogin() {
  const { user } = useSelector((state) => state.user, shallowEqual);
  const { profile } = useSelector((state) => state.profile, shallowEqual);
  const { companies } = useSelector((state) => state.companies, shallowEqual);
  const [claimantFormValues, setClaimantFormValues] = React.useState({});
  const [formStep, setFormStep] = React.useState(1);
  const [grpName, setGrpName] = React.useState("");

  const dispatch = useDispatch();
  const loading = !profile.user || !user.email || companies.length === 0;

  const IntroFormContextProvider = introFormContext.Provider;

  useEffect(() => {
    if (isDigipub) {
      setGrpName("digipub");
      dispatch(getCompaniesByGroupAnonymous("digipub"));
    } else if (isViacom) {
      setGrpName("viacom18");
      dispatch(getCompaniesByGroupAnonymous("viacom18"));
    } else if (isHotStar) {
      setGrpName("hotstar");
      dispatch(getCompaniesByGroupAnonymous("hotstar"));
    } else if (isStar) {
      setGrpName("star");
      dispatch(getCompaniesByGroupAnonymous("star"));
    } else if (isMuthoot) {
      setGrpName("muthoot");
      dispatch(getCompaniesByGroupAnonymous("muthoot"));
    } else if (isOrix) {
      setGrpName("orix");
      dispatch(getCompaniesByGroupAnonymous("orix"));
    } else if (isNbf) {
      setGrpName("nbf");
      dispatch(getCompaniesByGroupAnonymous("nbf"));
    } else if (isBarAndBench) {
      setGrpName("barandbench");
      dispatch(getCompaniesByGroupAnonymous("barandbench"));
    } else {
      setGrpName("webnyay");
      dispatch(getCompaniesByGroupAnonymous("webnyay"));
    }
  }, []);

  // if (loading) return <CircularProgress />;

  function filterCompnay(filter) {
    let result = [];
    companies.forEach((item) => {
      if (item.platform_type == filter) result.push(item);
    });
    return result;
  }

  let companys = "";
  if (grpName === "webnyay") {
    if (isWebnyay || isDigipub) {
      companys = filterCompnay("grievance");
    } else if (isCDR || isVikalp) {
      companys = filterCompnay("cdr");
    }
  }

  return (
    <IntroFormContextProvider
      value={{
        isVendor: false,
        claimantFormValues,
        setClaimantFormValues,
        setFormStep,
      }}
    >
      <Intro
        loading={loading}
        user={user}
        profile={profile}
        companies={grpName === "webnyay" ? companys : companies}
        formStep={formStep}
      />
    </IntroFormContextProvider>
  );
}
